import { UpdateUserDto, UserDto } from "@custom-types/user"

export const getUserUpdateDtoFromUserData = (userData: UserDto): UpdateUserDto => ({
  key: userData.key,
  organisation_key: userData.organisation_key,
  first_name: userData.first_name,
  last_name: userData.last_name,
  active: userData.active,
  last_updated: userData.last_updated,
  last_login: userData.last_login,
})
